<template>
  <div class="park-detail">
    <div
      style="margin-bottom: 15px; color: #057ee5; cursor: pointer"
      @click="$router.go(-1)"
    >
      <i class="el-icon-arrow-left"></i>
      <span> 返回列表</span>
    </div>
    <!-- <div class="project-location">
      <img src="../../assets/images/common/img10.png" alt="" @click="goMap" />

    </div> -->
    <div class="park-detail-base">
      <div class="park-detail-base-title">
        {{ projectDetails.projectName }}
      </div>
      <div class="project-address">
        <span>{{ projectDetails.countyName }}</span>
        <div class="line" v-if="projectDetails.parkName"></div>
        <span>{{
          projectDetails.parkName ? projectDetails.parkName : ""
        }}</span>
        <div class="line"></div>
        <span>{{ projectDetails.area }}亩</span>
        <!-- <span>{{}}</span> -->
      </div>
      <!-- <div class="contact">
        <div style="margin-left: 15px;padding-top: 10px;">
          联系人：{{ projectDetails.concatPerson }}
        </div>
        <div style="margin-left: 15px;margin-top: 10px;">
          联系单位：{{ projectDetails.contactUnit }}
        </div>
        <div style="margin-left: 15px;padding-top: 10px; padding-bottom: 10px;">
          联系电话： {{ projectDetails.phone }}
        </div>
      </div> -->
      <div class="project-container">
        <div class="project-container-box">
          <div class="project-container-title">项目类型</div>
          <div class="project-container-content">
            {{
              projectDetails.projectType == 1 ? "用地类项目" : "非用地类项目"
            }}
          </div>
        </div>
        <div class="project-container-box">
          <div class="project-container-title">产业类别</div>
          <div class="project-container-content">
            {{ projectDetails.industryChainCategory }}
          </div>
        </div>
        <div class="project-container-box">
          <div class="project-container-title">行业类型</div>
          <div class="project-container-content">
            <div>
              <span
                style="color: #292929; font-size: 13px"
                v-for="(item, index) in tablist"
                :key="index"
                v-show="tablist.length"
                >{{ item.labelName }}</span
              >
              <span v-show="!tablist.length">-</span>
            </div>
          </div>
        </div>
        <div class="project-container-box">
          <div class="project-container-title">投资估算</div>
          <div class="project-container-content">
            {{ projectDetails.investmentEstimate }}万（人民币）
          </div>
        </div>
        <div class="project-container-box">
          <div class="project-container-title">筹措方式</div>
          <div
            class="project-container-content"
            v-if="projectDetails.moneyStyle"
          >
            {{ projectDetails.moneyStyle }}
          </div>
          <div v-else>--</div>
        </div>
        <div class="project-container-box1">
          <div class="project-container-title">项目选址</div>
          <div class="project-container-content1">
            {{ projectDetails.location }}
          </div>
        </div>
      </div>
    </div>
    <el-tabs type="border-card" v-model="activeName" class="content-tab">
      <el-tab-pane label="项目概况" name="项目概况">
        <div class="project-title-details">建设内容</div>
        <div class="project-content">
          <div
            v-html="projectDetails.buildContent"
            v-if="projectDetails.buildContent"
          ></div>
          <div v-else>暂无内容</div>
        </div>
        <div class="project-title-details">项目优势</div>
        <div class="project-content">
          {{ projectDetails.advantage ? projectDetails.advantage : "暂无内容" }}
        </div>
        <div class="project-title-details">支持政策</div>
        <div class="project-content">
          {{ projectDetails.policy ? projectDetails.policy : "暂无内容" }}
        </div>
        <div class="project-title-details">要素保障</div>
        <div class="project-content">
          {{ projectDetails.provide ? projectDetails.provide : "暂无内容" }}
        </div>
        <div class="project-title-details">联系方式</div>
        <div>
          <div class="project-content">
            <div>{{ projectDetails.concatPerson }}</div>
            <div>{{ projectDetails.contactUnit }}</div>
            <div>{{ projectDetails.phone }}</div>
          </div>
        </div>
      </el-tab-pane>
      <!-- <el-tab-pane label="项目优势" name="项目优势">
        <div class="project-content" v-if="projectDetails.advantage">
          {{ projectDetails.advantage }}
        </div>
        <div class="unavailable" v-else>
          <img src="@/assets/images/unavailable.png" alt="" />
        </div>
      </el-tab-pane>
      <el-tab-pane label="支持政策" name="支持政策">
        <div class="project-content" v-if="projectDetails.policy">
          {{ projectDetails.policy }}
        </div>
        <div class="unavailable" v-else>
          <img src="@/assets/images/unavailable.png" alt="" />
        </div>
      </el-tab-pane>
      <el-tab-pane label="要素保障" name="要素保障">
        <div class="project-content" v-if="projectDetails.provide">
          {{ projectDetails.provide }}
        </div>
        <div class="unavailable" v-else>
          <img src="@/assets/images/unavailable.png" alt="" />
        </div>
      </el-tab-pane> -->

      <el-tab-pane label="可选范围" name="可选范围">
        <!-- v-if="landDetailData.sliceId" -->
        <div class="illustrate">
          *范围相关信息仅供参考，最终选址，以选址意见为准。
        </div>
        <div
          class="other-box-l-li-p-map"
          style="height: 700px; position: relative"
          v-if="activeName == '可选范围'"
        >
          <tz-map
            ref="map"
            :position="position"
            container="mapView"
            mw="100%"
            mh="100%"
            :maxZoom="18"
          >
          </tz-map>
          <div class="fw">
            <div class="fw-title">图例</div>
            <!-- <div class="fw-b">
              <div class="fw-box fw-box1"></div>
              <div>行政区划范围</div>
            </div> -->
            <div class="fw-b" v-if="projectDetails.parkCode">
              <div class="fw-box fw-box2"></div>
              <div>开发区范围</div>
            </div>
            <!-- <div class="fw-b">
              <div class="fw-box fw-box4"></div>
              <div>地块范围</div>
            </div> -->
            <!-- <div class="fw-b" v-if="projectDetails.rangeType != 2">
              <div class="fw-box fw-box3"></div>
              <div>项目矢量范围</div>
            </div> -->

            <div class="fw-b" v-for="(item, index) in exampleList" :key="index">
              <img class="fw-img" v-if="levels <= 12" :src="item.bgc" alt="" />
              <div
                class="fw-box"
                v-if="levels > 12"
                :style="{ background: item.bgc2 }"
              ></div>
              <div>{{ item.name }}</div>
            </div>
            <!-- <div class="fw-b">
              <div class="fw-box fw-box3"></div>
              <div>批而未供</div>
            </div> -->
          </div>
          <mapImage></mapImage>
          <div class="land-screen">
            <div
              :class="[
                'land-screen-btn',
                supplyPeriod == null ? 'land-screen-active-btn' : '',
              ]"
              @click="changeSupplyPeriod(null)"
            >
              全部
            </div>
            <div
              :class="[
                'land-screen-btn',
                supplyPeriod == 1 ? 'land-screen-active-btn' : '',
              ]"
              @click="changeSupplyPeriod(1)"
            >
              立等可供
            </div>
            <div
              :class="[
                'land-screen-btn',
                supplyPeriod == 3 ? 'land-screen-active-btn' : '',
              ]"
              @click="changeSupplyPeriod(3)"
            >
              计划可供
            </div>
            <div
              :class="[
                'land-screen-btn',
                supplyPeriod == 4 ? 'land-screen-active-btn' : '',
              ]"
              @click="changeSupplyPeriod(4)"
            >
              规划可用
            </div>
          </div>
          <div class="land-list scrollbar-definition" ref="box">
            <!--  -->
            <transition name="el-fade-in-linear">
              <div v-show="isExpand" class="land-list-box">
                <div v-if="supplyPeriod == 4" class="programme">
                  <div class="programme-left">
                    截止目前，项目拟选址范围内，约
                    <span style="color: rgb(146, 8, 250)">{{ areaCount }}</span>
                    亩符合国土空间规划的土地可用，具体选址请与属地投促部门和自然资源部门联系。
                  </div>
                  <div class="programme-right"></div>
                </div>
                <div
                  v-show="supplyPeriod != 4"
                  v-for="(item, index) in tableData"
                  :key="index"
                  :class="[
                    'land-list-box-li',
                    activeIndex == index ? 'land-list-box-li-active' : '',
                  ]"
                  @click="
                    drawLand(item.id);
                    activeIndex = index;
                  "
                >
                  <div class="land-list-box-li-l">
                    <img
                      :src="
                        item.supplyPeriod == 1
                          ? require('@/assets/images/ldkg.png')
                          : item.supplyPeriod == 3
                          ? require('@/assets/images/jhkg.png')
                          : ''
                      "
                      alt=""
                    />
                  </div>
                  <div class="land-list-box-li-r">
                    <div class="land-list-box-li-r-title">
                      {{ item.parcelName }}
                    </div>
                    <div
                      class="land-list-box-li-r-span"
                      :style="{
                        color:
                          item.supplyPeriod == 1
                            ? '#02D64A'
                            : item.supplyPeriod == 3
                            ? '#497AFF'
                            : '',
                      }"
                    >
                      {{
                        item.supplyPeriod == 1
                          ? "立等可供"
                          : item.supplyPeriod == 3
                          ? "计划可供"
                          : ""
                      }}
                    </div>
                  </div>
                </div>
                <div
                  v-if="!tableData.length && supplyPeriod != 4"
                  style="text-align: center; font-size: 13px"
                >
                  暂无数据
                </div>

                <!-- <div class="land-list-box-title">地块列表</div>
                <div>
                  <el-table
                    :data="tableData"
                    style="width: 100%"
                    border
                    max-height="600"
                  >
                    <el-table-column
                      label="地块名称"
                      width="180"
                      align="center"
                    >
                      <template slot-scope="scope">{{
                        scope.row.parcelName
                      }}</template>
                    </el-table-column>
                    <el-table-column label="定位" align="center" width="100">
                      <template slot-scope="scope">
                        <el-button
                          type="primary"
                          icon="el-icon-map-location"
                          @click="getLandInfo(scope.row)"
                        >
                          定位
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div> -->
              </div>
            </transition>
          </div>
          <!-- <div
            class="land-list-icon"
            @click="isExpand = !isExpand"
            :style="{ left: isExpand ? '310px' : '10px' }"
          >
            <i class="el-icon-arrow-left" v-show="isExpand"></i>
            <i class="el-icon-arrow-right" v-show="!isExpand"></i>
          </div> -->
          <!-- <div
            class="land-list1"
            v-if="projectDetails.projectName == '德宏州陇川县晟泰服装项目'"
          >
            <transition name="el-fade-in-linear">
              <div class="land-list-box" v-show="isExpand1">
                <div class="land-list-box-title">批而未供列表</div>
                <div>
                  <el-table
                    :data="tableData1"
                    style="width: 100%"
                    border
                    max-height="600"
                  >
                    <el-table-column
                      label="批复文号"
                      width="180"
                      align="center"
                    >
                      <template slot-scope="scope">{{
                        scope.row.parcelName
                      }}</template>
                    </el-table-column>
                    <el-table-column label="定位" align="center" width="100">
                      <template slot-scope="scope">
                        <el-button
                          type="primary"
                          icon="el-icon-map-location"
                          @click="getLandInfo1(scope.row)"
                        >
                          定位
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </transition>
            <div class="land-list-icon" @click="isExpand1 = !isExpand1">
              <i class="el-icon-arrow-left" v-show="isExpand1"></i>
              <i class="el-icon-arrow-right" v-show="!isExpand1"></i>
            </div>
          </div> -->
        </div>
        <!-- <div class="unavailable" v-else>
          <img src="@/assets/images/unavailable.png" alt="" />
        </div> -->
        <!-- <div class="other-box-l-li-p-box" v-else>暂无数据</div> -->
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import projectInfo from "@/map/projectInfo.js";
import mapImage from "@/components/mapImage";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import "quill-better-table/dist/quill-better-table.css";
import Swiper from "swiper/swiper-bundle.min";
import img03 from "@/assets/images/land/ldkg1.png";
import img04 from "@/assets/images/land/jqkg1.png";
import img05 from "@/assets/images/land/jhkg1.png";
import "swiper/swiper-bundle.min.css";
import VideoDialog from "@/components/currency/videoDialog";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import LandPlace from "@/views/land/components/LandPlace";
import LandPopularPush from "@/views/land/components/LandPopularPush";
import Concert from "@/map/Convert";
import {
  getProjectShp,
  landPriceData,
  projectParcelList,
  projectNearlList,
  projectlandList,
  getParkCodeShp,
  getShp,
  getLandInfoTwo,
  getParcelRange,
  getPewgShp,
  getPewgParcelArea,
  getAllShpProjectByScope,
} from "@/api/setting/investment";
import landDetailInfo from "@/map/landDetailInfo.js";
import DoubleClickZoom from "ol/interaction/DoubleClickZoom.js";
import mapEvent from "@/map/mapEvent.js";
import {
  getProjectDetails,
  inquireKGDK,
  getCoverageInfo,
  inquireKGDKnearby,
  projectGetTag,
  projectPictureId,
} from "@/api/setting/project";
import { dictionaries, getCountyShp } from "@/api/common/index.js";

/**
 * @Description 地块详情
 */
export default {
  name: "LandDetail",
  components: {
    LandPopularPush,
    LandPlace,
    ElImageViewer,
    VideoDialog,
    mapImage,
  },
  data() {
    return {
      activeIndex: null,
      supplyPeriod: null,
      isExpand: true,
      isExpand1: true,
      rootProject: undefined,
      example: [
        { title: "行政区划范围", bgc: "#eb8d13" },
        { title: "开发区范围", bgc: "#aaeb13" },
        { title: "地块范围", bgc: "#04ebf0" },
        { title: "项目范围", bgc: "#3196c9" },
      ],
      exampleList: [
        {
          name: "立等可供",
          bgc: require("@/assets/images/tl1.png"),
          bgc2: "#02D64A",
          bgc1: "#02d64a80",
        },
        {
          name: "计划可供",
          bgc: require("@/assets/images/tl3.png"),
          bgc2: "#497AFF",
          bgc1: "#497aff80",
        },
        {
          name: "规划可用",
          bgc: require("@/assets/images/tl2.png"),
          bgc2: "#FFAE11",
          bgc1: "#ffae1180",
        },
      ],
      levels: 7,
      shapeInfo: [],
      img01: img03,
      img02: img04,
      img03: img05,
      mapEvents: null,
      areaShow: false, //是否显示所属片区
      detailDialogShow: false, //展示片区弹窗
      position: [100.264162, 25.615269],
      configList: mapConfig.configList[1],
      landDetailData: {
        // sliceId: null,
      }, //详情信息
      landFileInfo: {}, //文件信息
      fileShp: {}, //图形数据
      imgUrl: systemConfig.imgServer + systemConfig.imgApi,
      playVideo: {
        show: false,
        src: undefined,
        title: undefined,
      },
      previewImage: {
        show: false,
        urlList: [],
        index: 0,
      },

      markFontColor: {
        type: String,
        default: "#000",
      },

      factorIndex: null, //要素类型下标
      factorList: [], //要素列表

      activeName: "项目概况",
      activeName1: "出让公告",
      developData: "展开更多",
      developData1: "展开更多",
      iconEdit: "el-icon-arrow-down",
      iconEdit1: "el-icon-arrow-down",
      listData: {},
      priceData: [],
      price: [],
      // 图形文件的经纬度数据
      properties: {},
      showPrice: false,
      policyInfos: [], //政策列表
      priceInfo: {
        czjzdj: "--元/㎡",
        bzdj: "--元/㎡",
        jtjsyddj: "--元/㎡",
        csdjdtjc: {},
      },
      crggHtml: "", //出让公告
      crgsHtml: "", //成交公示
      projectDetails: {
        id: null,
        classify: "",
      },
      dklist: [],
      dknearbylist: [],
      mapView: null,
      tablist: [],
      appointList: [], //精准匹配
      mateList: [], //精准推荐
      peripheryList: [], //周边地块
      imgUrl: systemConfig.imgServer + systemConfig.imgApi,
      infoId: null,
      projectLevelList: [],
      projectFileList: [],
      srcList: [],
      tableData: [],
      tableData1: [],
      areaCount: null,
      ghkyList: [], //规划可用列表
    };
  },
  created() {
    this.concert = new Concert();
  },
  watch: {
    $route(to) {
      if (to.path == "/project/detail") {
        location.reload(true);
        // console.log("第二次进来");
      }
    },
    supplyPeriod: function (val) {
      this.activeIndex = null;
      if (val == "") {
        //删除面
        this.removeLandLayer();
        //删除点
        this.removeLandSpotList();
      }
      if (val != "" && val != 4) {
        let params = {
          county: this.projectDetails.county,
          supplyPeriod: val,
          parkCode: this.projectDetails.parkCode,
        };
        this.getList(params);
      }
      if (val == 4) {
        this.getArea();
        if (this.levels > 12) {
          //添加面
          this.addLandLayerList();
          //删除点
          this.removeLandSpotList();
        } else {
          //删除面
          this.removeLandLayer();
          //添加点
          this.addLandSpotList();
        }
      }
    },
    activeName: function (val) {
      if (val == "可选范围") {
        this.$nextTick(() => {
          this.mapView = this.$refs.map.tzApi;
          systemConfig.mapApi = this.mapView;
          systemConfig.olApi = this.$refs.map.olApi;
          this.mapView.map.addInteraction(new DoubleClickZoom());
          systemConfig.mapApi = this.mapView;
          let code = "";
          //添加影像底图
          let param = this.convert(this.configList.mapconfig.args);
          code = `this.mapView.${this.configList.mapconfig.func}(${param})`;
          eval(code);
          // if (this.projectDetails.projectName == "德宏州陇川县晟泰服装项目") {
          //   this.getPewgShps();
          // }
          // this.getPewgShps();
          if (this.configList.note.openSymbol) {
            this.addLayer(this.configList.note.mapconfig);
          }
          //行政区划范围
          this.xzqhRange();
          // this.townRange();

          if (this.projectDetails.parkCode) {
            this.parkRange();
          }

          //获取项目图形文件
          // this.getShp(this.infoId);
          // if (this.projectDetails.parcelIds) {
          //   this.projectDetails.parcelIds.forEach((item, index) => {
          //     let isCase =
          //       index + 1 == this.projectDetails.parcelIds.length
          //         ? true
          //         : false;
          //     this.drawLand(item, isCase);
          //   });
          // }
          // if (this.tableData.length) {
          //   this.tableData.forEach((item) => {
          //     this.drawLand(item.id);
          //   });
          // }
          //面
          // if (
          //   this.projectDetails.rangeType == 1 &&
          //   this.projectDetails.geom &&
          //   this.projectDetails.geom.coordinates
          // ) {
          //   this.projectDetails.geom.coordinates = JSON.parse(
          //     this.projectDetails.geom.coordinates
          //   );

          //   this.drawProject({
          //     geom: this.projectDetails.geom,
          //   });
          // }
          //图形数据
          // if (this.projectDetails.rangeType == 3) {
          //   this.getShp(this.projectDetails.id);
          // }
          //点
          if (this.projectDetails.rangeType == 2) {
            //if (this.projectDetails.lng && this.projectDetails.lat) {
            //   this.rootProject = new projectInfo();
            //   this.rootProject.showMapTip(
            //     [this.projectDetails.lng, this.projectDetails.lat],
            //     this.projectDetails.projectName
            //   );
            //   this.mapView.flyTo([
            //     this.projectDetails.lng,
            //     this.projectDetails.lat,
            //   ]);
            // }
          }
          //监听点击事件
          this.mapView.addSingleClickCallBack((arg1, xy) => {
            let attribute = arg1.getProperties();
            //判断地块面点击
            if (attribute.ids && attribute.ids.indexOf("landLayer_") != -1) {
              getLandInfoTwo(attribute.fromDataId).then((res) => {
                if (res.data.success) {
                  let data = res.data.data;
                  this.root = new landDetailInfo();
                  let routerData = this.$router;
                  this.root.showMapTip(
                    [attribute.lng, attribute.lat],
                    data,
                    routerData
                  );
                }
              });
            }
            if (attribute.ids && attribute.ids.indexOf("spot_") != -1) {
              this.drawLand(attribute.id);

              getLandInfoTwo(attribute.id).then((res) => {
                if (res.data.success) {
                  let data = res.data.data;
                  this.root = new landDetailInfo();
                  let routerData = this.$router;
                  this.root.showMapTip(
                    [attribute.lng, attribute.lat],
                    data,
                    routerData
                  );
                }
              });
            }
          });
          let me = this;
          //监听地图层级
          me.mapView.addMoveendCallBack(function (res) {
            let zoomObj = me.mapView.getZoomInfo();
            let level = Math.round(zoomObj.zoom);
            me.levels = level;
            // if (level > 8) {
            //   me.mapView.setLayerVisible("countyLayer", false);
            // }
            // if (level < 9 && layerData[2].isShow) {
            //   me.mapView.setLayerVisible("countyLayer", true);
            // }
            if (me.levels > 12) {
              //添加面
              me.addLandLayerList();
              //删除点
              me.removeLandSpotList();
            } else {
              //删除面
              me.removeLandLayer();
              //添加点
              me.addLandSpotList();
            }
          });
        });
      }
    },

    factorList: {
      deep: true,
      handler(val, oldVal) {
        if (oldVal && oldVal.length) {
          oldVal.forEach((item) => {
            let str = "type" + item.type + "_" + item.id;
            this.mapView.removeVectorFeatureById(str);
          });
        }
        if (val && val.length) {
          val.forEach((item) => {
            let coordinate = [item.centerX, item.centerY];
            let img = this.typeList[item.type].img;
            this.draw(
              coordinate,
              img,
              item.name,
              "type" + item.type + "_" + item.id
            );
          });
        }
      },
    },
  },
  activated() {},
  mounted() {
    let id = this.$route.query.id;
    this.infoId = id;
    this.initializePageInfo();
    // this.getProjectlandList(id);
    // this.getProjectNearlList(id);
    // this.getProjectParcelList(id);
    this.getField("projectLevel", "projectLevelList");

    // this.getLandInfoLoginData()
  },
  methods: {
    changeSupplyPeriod(val) {
      this.tableData = [];
      if (this.supplyPeriod == val) {
        this.supplyPeriod = "";
        this.isExpand = false;
      } else {
        this.supplyPeriod = val;
        this.isExpand = true;
      }
      if (val == 4) {
        this.$refs.box.style.background =
          "linear-gradient(to bottom, #FDF8CE, #FFFFFF)";
      } else {
        this.$refs.box.style.background = "#fff";
      }
    },
    getArea() {
      getPewgParcelArea(this.infoId).then((res) => {
        if (res.data.success) {
          this.areaCount = res.data.data;
        }
      });
    },
    //获取批而未供图形
    getPewgShps() {
      getPewgShp(this.infoId).then((res) => {
        if (res.data.success) {
          let data = res.data.data;
          let geojson = this.concert.toGeoJson(
            data,
            "geom",
            ["supplyPeriod", "fromDataName", "lng", "lat"],
            4490
          );
          let that = this;
          this.mapView.addGeojsonMapLayer(
            geojson,
            "pewgLayer",
            30,
            1,
            undefined,
            undefined,
            (feature) => {
              let properties = feature.getProperties();
              return that.mapView.setPolygonStyle(
                properties.fromDataName,
                "rgba(0,0,0,0)",
                "#2211a7cc",
                "#fff",
                undefined,
                undefined,
                undefined,
                4
              );
            }
          );
          this.mapView.zoomToExtentByLayerId("pewgLayer");
        }
      });
    },
    //获取工矿列表
    getList(params) {
      getParcelRange(params).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.data;
          this.removeLandSpotList();
          this.removeLandLayer();
          if (this.activeName == "可选范围" && this.mapView) {
            if (this.levels > 12) {
              //添加面
              this.addLandLayerList();
              //删除点
              this.removeLandSpotList();
            } else {
              //删除面
              this.removeLandLayer();
              //添加点
              this.addLandSpotList();
            }
          }
        }
      });
    },
    getGhkyList(params) {
      getParcelRange(params).then((res) => {
        if (res.data.success) {
          this.ghkyList = res.data.data;
          if (this.activeName == "可选范围" && this.mapView) {
            if (this.levels > 12) {
              //添加面
              this.addLandLayerList();
              //删除点
              this.removeLandSpotList();
            } else {
              //删除面
              this.removeLandLayer();
              //添加点
              this.addLandSpotList();
            }
          }
        }
      });
    },
    //删除用地点
    removeLandSpotList() {
      this.mapView.removeLayer("landPointLayerId");
    },
    //删除用地面图层
    removeLandLayer() {
      this.mapView.removeLayer("layerLand");
    },
    //添加用地面
    addLandLayerList() {
      let data = this.mapView.getViewExtent(); //获取视图范围
      let scope = [
        [data[0], data[3]],
        [data[2], data[3]],
        [data[2], data[1]],
        [data[0], data[1]],
        [data[0], data[3]],
      ];
      let obj = {
        scope: {
          type: "MultiPolygon",
          coordinates: [[scope]],
        },
        supplyPeriod: this.supplyPeriod,
        parkCode: this.projectDetails.parkCode
          ? this.projectDetails.parkCode
          : "",
      };
      this.mapView.removeLayer("layerLand");
      getAllShpProjectByScope(obj).then((res) => {
        if (res.data.success) {
          let data = res.data.data;
          let geojson = this.concert.toGeoJson(
            data,
            "geom",
            ["fromDataName", "supplyPeriod", "lng", "lat", "fromDataId"],
            4490
          );
          let that = this;
          this.mapView.addGeojsonMapLayer(
            geojson,
            "layerLand",
            99,
            1,
            undefined,
            undefined,
            (feature) => {
              let properties = feature.getProperties();
              let ids = "landLayer_" + properties.fromDataId;
              let fillColor =
                properties.supplyPeriod == 1
                  ? "#02d64a80"
                  : properties.supplyPeriod == 3
                  ? "#497aff80"
                  : properties.supplyPeriod == 4
                  ? "#ffae1180"
                  : "#cccccc"; //填充色
              feature.setProperties({
                ids: ids,
              });
              return that.mapView.setPolygonStyle(
                properties.fromDataName,
                "rgba(0,0,0,0)",
                fillColor,
                "#fff",
                undefined,
                undefined,
                undefined,
                4
              );
            }
          );
        }
      });
      // if (this.tableData.length) {
      //   this.tableData.forEach((item) => {
      //     this.drawLand(item.id);
      //   });
      // }
      // if (this.ghkyList.length) {
      //   this.ghkyList.forEach((item) => {
      //     this.drawLand(item.id);
      //   });
      // }
    },
    //添加用地点
    addLandSpotList() {
      let data = [];
      if (this.supplyPeriod == null) {
        data = [...this.tableData, ...this.ghkyList];
      }
      if (this.supplyPeriod == 1 || this.supplyPeriod == 3) {
        data = this.tableData;
      }
      if (this.supplyPeriod == 4) {
        data = this.ghkyList;
      }
      this.mapView.removeLayer("landPointLayerId");
      data.forEach((item) => {
        let geometry = {
          type: "Point",
          coordinates: [item.lng, item.lat],
        };
        this.$set(item, "geometry", geometry);
      });
      let geojson = this.concert.toGeoJson(
        data,
        "geometry",
        ["parcelName", "id", "lng", "lat", "supplyPeriod"],
        4490
      );
      this.mapView.addGeojsonMapLayer(
        geojson,
        "landPointLayerId",
        100,
        1,
        undefined,
        undefined,
        (feature) => {
          let properties = feature.getProperties();
          // let fromDataId = properties.id;
          let ids = "spot_" + properties.id;
          // let center = [properties.lng, properties.lat];
          let imgUrl =
            properties.supplyPeriod == 1
              ? this.exampleList[0].bgc
              : properties.supplyPeriod == 3
              ? this.exampleList[1].bgc
              : properties.supplyPeriod == 4
              ? this.exampleList[2].bgc
              : "";
          feature.setProperties({
            ids: ids,
            // fromDataId: fromDataId,
            // center: center,
          });
          return this.mapView.setPointStyle("", imgUrl, 1);
        }
      );
    },
    //点击定位地块
    getLandInfo(info) {
      this.mapView.zoomToExtentByLayerId("landLayer_" + info.id);
    },
    getLandInfo1() {
      this.mapView.zoomToExtentByLayerId("pewgLayer");
    },
    //画用地范围
    drawLand(id) {
      getShp(id).then((res) => {
        if (res.data.success) {
          let data = res.data.data;
          if (!data.shapeInfo.length) {
            return false;
          }
          this.mapView.removeLayer("layerLand");

          let geojson = this.concert.toGeoJson(
            data.shapeInfo,
            "geom",
            ["fromDataName", "supplyPeriod", "lng", "lat", "fromDataId"],
            4490
          );

          let that = this;
          this.mapView.addGeojsonMapLayer(
            geojson,
            "layerLand",
            99,
            1,
            undefined,
            undefined,
            (feature) => {
              let properties = feature.getProperties();
              let ids = "landLayer_" + properties.fromDataId;
              let fillColor =
                properties.supplyPeriod == 1
                  ? "#02d64a80"
                  : properties.supplyPeriod == 3
                  ? "#497aff80"
                  : properties.supplyPeriod == 4
                  ? "#ffae1180"
                  : "#cccccc"; //填充色
              feature.setProperties({
                ids: ids,
              });
              return that.mapView.setPolygonStyle(
                properties.fromDataName,
                "rgba(0,0,0,0)",
                fillColor,
                "#fff",
                undefined,
                undefined,
                undefined,
                4
              );
            }
          );
          this.mapView.zoomToExtentByLayerId("layerLand");
          // data.shapeInfo.forEach((item, index) => {
          //   let ids = "selectLand_" + id;
          //   console.log(ids, "ids");

          //   this.mapView.addVectorMultiPolygon(
          //     item.geom.coordinates,
          //     item.fromDataName,
          //     { id: ids },
          //     "#3196c9",
          //     "rgba(255,255,255,0.2)",
          //     "#3196c9",
          //     "#fff",
          //     undefined,
          //     undefined,
          //     4
          //   );
          //   if (isCase && index == 0) {
          //     let extent = this.mapView.getMultiPolygonExtent(
          //       item.geom.coordinates
          //     );
          //     this.mapView.zoomToExtent(
          //       extent[0],
          //       extent[1],
          //       extent[2],
          //       extent[3]
          //     );
          //   }
          // });
        }
      });
    },
    getField(field, identification) {
      let data = { field: field };
      dictionaries(field).then((res) => {
        this[identification] = res.data.data;
      });
    },
    getLable(arr) {
      let str = "";
      arr = JSON.parse(arr);
      if (arr.length) {
        arr.forEach((j, i) => {
          let index = this.projectLevelList.findIndex(
            (item) => item.value == j
          );
          if (i != arr.length - 1 && index != -1) {
            str = str + "、" + this.projectLevelList[index].label;
          }
          if (i == arr.length - 1 && index != -1) {
            str = str + this.projectLevelList[index].label;
          }
        });
      }
      return str;
    },
    //精准
    getProjectlandList(id) {
      projectlandList(id).then((res) => {
        if (res.data.success) {
          this.appointList = res.data.data;
        }
      });
    },
    //周边
    getProjectNearlList(id) {
      projectNearlList(id).then((res) => {
        this.peripheryList = res.data.data;
      });
    },
    //推荐
    getProjectParcelList(id) {
      projectParcelList(id).then((res) => {
        this.mateList = res.data.data;
      });
    },
    //园区范围
    parkRange() {
      let parkCodeActual = this.projectDetails.parkCode;
      getParkCodeShp(parkCodeActual).then((res) => {
        if (res.data.success) {
          let data = res.data.data;

          let geojson = this.concert.toGeoJson(
            data,
            "geom",
            ["fromDataName", "lng", "lat"],
            4490
          );
          let that = this;
          this.mapView.addGeojsonMapLayer(
            geojson,
            "parkLayer",
            99,
            1,
            undefined,
            undefined,
            (feature) => {
              let properties = feature.getProperties();
              return that.mapView.setPolygonStyle(
                properties.fromDataName,
                "#aaeb13",
                "rgba(0,0,0,0)",
                undefined,
                undefined,
                undefined,
                undefined,
                4
              );
            }
          );
          if (
            !this.projectDetails.parcelIds ||
            !this.projectDetails.parcelIds.length
          ) {
            that.mapView.zoomToExtentByLayerId("parkLayer");
          }
        }
      });
    },

    //画行政区划范围
    xzqhRange() {
      getCountyShp({ county: this.projectDetails.county }).then((res) => {
        if (res.data.success) {
          let data = res.data.data;
          let extent = this.mapView.getMultiPolygonExtent(
            data.geom.coordinates
          );
          this.mapView.zoomToExtent(extent[0], extent[1], extent[2], extent[3]);
        }
      });
    },

    //画城市开发边界
    townRange() {
      let county = this.projectDetails.county;
      this.mapView.addArcGISRestLayer(townConfig.url, townConfig.layerId, 99);
    },

    // 初始化页面信息
    initializePageInfo() {
      // 查询招商项目信息详情
      getProjectDetails(this.$route.query.id).then((res) => {
        this.projectDetails = res.data.data;
        if (this.projectDetails.county) {
        }
        this.getList({
          county: this.projectDetails.county,
          supplyPeriod: this.supplyPeriod,
          parkCode: this.projectDetails.parkCode,
        });
        this.getGhkyList({
          county: this.projectDetails.county,
          supplyPeriod: 4,
          parkCode: this.projectDetails.parkCode,
        });
        // 字典查询
        dictionaries("CCFS").then((res) => {
          var zdlist = res.data.data;
          if (zdlist && zdlist.length) {
            for (let i = 0; i < zdlist.length; i++) {
              if (zdlist[i].value == this.projectDetails.moneyStyle) {
                this.projectDetails.moneyStyle = zdlist[i].label;
              }
            }
          }
        });
        let obj = {
          id: null,
          source: "3",
          type: "0",
        };
        obj.id = this.projectDetails.industryChainCategoryId;
        if (this.projectDetails.industryCategoryId) {
          var arr = this.projectDetails.industryCategoryId.split(",");
          projectGetTag(obj).then((res) => {
            if (arr.length > 0) {
              for (let i = 0; i < arr.length; i++) {
                if (arr[i] == res.data.data[i].labelId) {
                  this.tablist.push(res.data.data[i]);
                }
              }
            }
          });
        }
      });

      //根据数据id获取招商项目图形信息
      // getCoverageInfo(this.$route.query.id).then((res) => {});
      // 可选地块查询
      // inquireKGDK(this.$route.query.id).then((res) => {});
      // 周边可选地块查询
      // inquireKGDKnearby(this.$route.query.id).then((res) => {
      //   this.dklist = res.data.data;
      //   if (this.dklist && this.dklist.length) {
      //     for (let i = 0; i < this.dklist.length; i++) {
      //       this.dklist[i].pronounceImages[0].filePath =
      //         systemConfig.imgServer +
      //         systemConfig.imgApi +
      //         this.dklist[i].pronounceImages[0].filePath;
      //     }
      //   }

      //   this.dknearbylist = [].concat(this.dklist).reverse();
      // });

      // 根据id获取文件
      projectPictureId(this.$route.query.id).then((res) => {
        if (res.data.success) {
          let data = res.data.data;
          data.pronounceImages = data.pronounceImages
            ? data.pronounceImages
            : [];
          if (data.pronounceImages.length) {
            data.pronounceImages.forEach((item) => {
              this.$set(
                item,
                "url",
                systemConfig.imgServer + systemConfig.imgApi + item.filePath
              );
              this.srcList.push(
                systemConfig.imgServer + systemConfig.imgApi + item.filePath
              );
            });
          }
          data.pronounceVideos = data.pronounceVideos
            ? data.pronounceVideos
            : [];
          if (data.pronounceVideos.length) {
            data.pronounceVideos.forEach((item) => {
              this.$set(
                item,
                "url",
                systemConfig.imgServer + systemConfig.imgApi + item.filePath
              );
              this.$set(
                item,
                "thumbnailSrc",
                systemConfig.imgServer + systemConfig.imgApi + item.thumbnail
              );
            });
          }
          data.pronounceFiles = data.pronounceFiles ? data.pronounceFiles : [];
          if (data.pronounceFiles.length) {
            data.pronounceFiles.forEach((item) => {
              this.$set(
                item,
                "url",
                systemConfig.imgServer + systemConfig.imgApi + item.filePath
              );
            });
          }
          data.pronounceApproval = data.pronounceApproval
            ? data.pronounceApproval
            : [];
          if (data.pronounceApproval.length) {
            data.pronounceApproval.forEach((item) => {
              this.$set(
                item,
                "url",
                systemConfig.imgServer + systemConfig.imgApi + item.filePath
              );
            });
          }
          this.projectFileList = data;
        }
      });
    },
    draws(coordinate) {
      this.mapView.removeVectorFeatureById("location");
      this.mapView.addVectorPoint(
        coordinate,
        this.form.name,
        require("@/assets/leadCockpitImage/land.png"),
        { id: "location" },
        "#000",
        "#fff",
        10,
        [0.5, 27],
        undefined,
        "13px"
      );
    },
    //画项目图形
    drawProject(data) {
      let geojson = this.concert.toGeoJson(data, "geom");
      let that = this;
      this.mapView.addGeojsonMapLayer(
        geojson,
        "projectLayer",
        100,
        1,
        undefined,
        undefined,
        (feature) => {
          return that.mapView.setPolygonStyle(
            "",
            that.example[3].bgc,
            "rgba(255,255,255,0.2)",
            undefined,
            undefined,
            undefined,
            undefined,
            4
          );
        }
      );
      this.mapView.zoomToExtentByLayerId("projectLayer");
    },
    //添加影像注记
    addLayer(conf) {
      let code,
        func = conf.func,
        param = this.convert(conf.args);
      code = `this.mapView.${func}(${param})`;
      eval(code);
    },
    // 获取地价
    getLandPrice(landDetailData, data) {
      if (!!data && !!data.shapeInfo && !!landDetailData.type) {
        let { lng, lat } = data.shapeInfo[0];
        let params = {
          tdyt: parseInt(landDetailData.type),
          lng: lng,
          lat: lat,
        };
        landPriceData(params).then((res) => {
          if (res.data.success) {
            let data = JSON.parse(res.data.data);
            // this.priceInfo = {
            //   czjzdj: "--元/㎡",
            //   bzdj: "元/㎡",
            //   jtjsyddj: "元/㎡",
            //   csdjdtjc: {},
            // };
            data.data.forEach((item) => {
              if (item.priceType == "标定地价") {
                this.priceInfo.bzdj = `(${item.landType}) ${
                  item.price ? item.price : "--"
                } 元/㎡`;
              }
              if (item.priceType == "城镇基准地价") {
                this.priceInfo.czjzdj = `(${item.landType}) ${
                  item.price ? item.price : "--"
                } 元/㎡`;
              }
              if (item.priceType == "集休建设用地地价") {
                this.priceInfo.jtjsyddj = `(${item.landType}) ${
                  item.price ? item.price : "--"
                } 元/㎡`;
              }
              if (item.priceType == "城市地价动态监测") {
                this.priceInfo.csdjdtjc = item;
              }
            });

            if (data.data.length > 0) {
              this.showPrice = true;
              this.priceData = data.data;
            } else {
              this.showPrice = false;
            }
          }
        });
      }
    },
    openAnnounce() {
      if (!!this.listData.transferAnnounceUrl) {
        window.open(this.listData.transferAnnounceUrl);
      } else if (!!this.landFileInfo.transferAnnounceFile) {
        let url = `${this.imgUrl}${this.landFileInfo.transferAnnounceFile[0].filePath}`;
        window.open(url);
      }
    },
    openPublicity() {
      if (!!this.listData.plotPublicityUrl) {
        window.open(this.listData.plotPublicityUrl);
      } else if (!!this.landFileInfo.plotPublicityFile) {
        let url = `${this.imgUrl}${this.landFileInfo.plotPublicityFile[0].filePath}`;
        window.open(url);
      }
    },
    // getLandInfoLoginData
    develop() {
      let dom = document.querySelector("#dom");
      if (!!dom) {
        if (this.developData1 === "展开更多") {
          this.developData1 = "收起";
          this.iconEdit1 = "el-icon-arrow-up";
          dom.style.height = "100%";
        } else {
          this.developData1 = "展开更多";
          this.iconEdit1 = "el-icon-arrow-down";
          dom.style.height = "350px";
        }
      }
    },
    develop2() {
      let dom = document.querySelector("#dom2");
      if (!!dom) {
        if (this.developData === "展开更多") {
          this.developData = "收起";
          this.iconEdit = "el-icon-arrow-up";
          dom.style.height = "100%";
        } else {
          this.developData = "展开更多";
          this.iconEdit = "el-icon-arrow-down";
          dom.style.height = "350px";
        }
      }
    },
    //周边企业打点
    draw(coordinate, img, name, id) {
      this.mapView.addVectorPoint(
        coordinate,
        name,
        img,
        { id: id },
        "#000",
        "#fff",
        20,
        [0.5, -27],
        undefined,
        "13px"
      );
    },

    previewOrDownFile(item) {
      let fileUrl = this.imgUrl + item.filePath; //所下载文件的网络地址
      const link = document.createElement("a");
      // this.loading=true
      fetch(fileUrl)
        .then((res) =>
          res
            .blob
            // window.location.href=fileUrl
            ()
        )
        .then((blob) => {
          // this.loading=false
          // 将链接地址字符内容转变成blob地址
          link.href = URL.createObjectURL(blob);
          link.download = item.fileTitle; //下载成功后保存的文件名
          document.body.appendChild(link);
          link.click();
        });
    },
    //获取可选范围
    getShp(id) {
      getProjectShp(id).then((res) => {
        if (res.data.success) {
          let data = res.data.data;
          this.shapeInfo = data.shapeInfo;
          if (data.shapeInfo && data.fileInfo) {
            let arr = data.shapeInfo;

            arr.forEach((item, index) => {
              this.mapView.addVectorMultiPolygon(
                item.geom.coordinates,
                "",
                undefined,
                "#3196c9",
                "#fff0",
                "#fff",
                "#007eff",
                undefined,
                undefined,
                3
              );

              if (index == 0) {
                //居中地图范围
                let extent = this.mapView.getMultiPolygonExtent(
                  item.geom.coordinates
                );

                this.mapView.zoomToExtent(
                  extent[0],
                  extent[1],
                  extent[2],
                  extent[3]
                );
              }
            });
            this.fileName = data.fileInfo.fileName;
          }
        }
      });
    },

    convert(args) {
      let param = args.map((item) => {
        switch (typeof item) {
          case "string":
            return `'${item}'`;
          case "object":
            return JSON.stringify(item);
          default:
            return `${item}`;
        }
      });
      return param;
    },

    goPark(id) {
      this.$router.push({ path: "/parkDetail", query: { id: id } });
    },
    //跳转我要用地
    goMap() {
      sessionStorage.setItem(
        "projectInfoDetail",
        JSON.stringify({
          name: this.projectDetails.projectName,
          id: this.projectDetails.id,
          type: "project",
          data: this.projectDetails,
        })
      );
      this.$router.push({
        path: "/needLand/indexCopy",
      });
    },
  },
  updated() {
    // this.$nextTick(() => {
    //   console.log(this.$refs.r1.clientHeight);
    //   this.$refs.l1.style.height = this.$refs.r1.clientHeight + 10 + "px";
    // });
  },
};
</script>

<style scoped>
.park-detail {
  padding: 10px 20px;
  width: calc(60% - 40px);
  margin: 0 auto;
  background: white;
}

.park-detail-base .disclaimer {
  font-size: 0.75rem;
  margin-top: 10px;
}

.park-detail-base .disclaimer span:first-child {
  color: red;
  font-size: 0.95rem;
}

.park-detail-base-img {
  width: 50%;
  height: 420px;
}

.park-detail-base-content {
  width: 50%;
  /* display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 20px 10px;
    font-size: 0.85rem;; */
}

.park-detail-base-content-li {
  width: 100%;
}

.park-detail-base-content-li-t {
  font-size: 0.85rem;
  font-weight: 600;
  color: #04469b;
  margin: 7px 0;
  display: flex;
}

.park-detail-base-content-li-c {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
}

.park-detail-base-content-li-c-li {
  display: flex;
  justify-content: space-between;
  margin: 3px 0;
}

.park-li-1 {
  width: 100%;
}

.park-li-2 {
  width: calc((100% - 14px) / 2);
}

.li-1 {
  width: 100px;
  font-size: 0.8rem;
  background: #edf5fe;
  color: #393939;
  display: flex;
  align-items: center;
  justify-content: center;
}

.span-content {
  padding: 6px 0;
  text-align: center;
}

.li-2 {
  width: calc(100% - 110px);
  font-size: 0.75rem;
  border: 1px solid #edf5fe;
}

.li-3 {
  width: calc((100% - 220px) / 2);
}

.park-detail-base-content-price {
  /* grid-column: 1 / -1; */
  height: 50px;
  padding: 0 4px;
  background: linear-gradient(90deg, #9fccff, #1f42a100);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.park-detail-base-content-price-text {
  font-weight: bold;
  font-size: 1rem;
  color: #0054bb;
  display: flex;
  align-items: center;
}

.go-map {
  margin-left: 5px;
  cursor: pointer;
}

.park-detail-base-content-price-span {
  font-size: 0.75rem;
  color: #837a7a;
}

.park-detail-base-content-price-img {
  width: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #0054bb;
  font-size: 0.8rem;
  cursor: pointer;
}

/*.park-detail-base-content-info {
  }

  .park-detail-base-content-info-key {
  }

  .park-detail-base-content-info-value {
  } */

/* .park-detail-top-title5-span2 {
    padding: 5px 10px;
    background: #01ba61;
  } */

.content-tab {
  margin-top: 20px;
}

::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  border: none !important;
  background: linear-gradient(90deg, #9fccff, #1f42a100);
  color: #0054bb;
}

::v-deep .el-tabs--border-card > .el-tabs__header {
  border-bottom: none !important;
}

::v-deep .el-tabs--border-card {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .el-tabs__item {
  font-weight: 600;
  font-size: 1rem;
  padding: 0 32px;
}

::v-deep .el-tabs--border-card > .el-tabs__content {
  padding: 15px 0;
}

/deep/ .el-tabs__content {
  min-height: 400px;
}

.availableNear {
  background: #497aff;
}

.available {
  background: #02d64a;
}

.availability {
  background: #ffb72b;
}

.availableNear1 {
  background: #5fbd37;
}

.available1 {
  background: #426ef3;
}

.availability1 {
  background: #d35cbf;
}

/deep/ .develop-style {
  font-size: 0.85rem;
  cursor: pointer;
  color: #1446a6;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #eaeefb;
  padding: 10px;
}

#dom {
  height: 350px;
  overflow: hidden;
  padding: 10px;
}

#dom2 {
  height: 350px;
  overflow: hidden;
  padding: 10px;
}

/deep/ table.quill-better-table {
  font-size: 0.75rem;
}

::v-deep .el-dialog__body {
  padding: 0px 20px 30px;
}

::v-deep .el-dialog__title {
  color: #004adf;
  font-weight: bold;
}

.unavailable {
  display: flex;
  justify-content: center;
  margin-top: 70px;
  height: 200px;
  /* background: red; */
}

.col-box {
  display: flex;
  line-height: 20px;
}

.col-r {
  width: calc(100% - 130px);
  margin-left: 10px;
  line-height: 20px;
  display: flex;
  flex-wrap: wrap;
}

.col-r > div {
  width: 50%;
}

.right-top {
  position: absolute;
  right: 5px;
  top: 5px;
  padding: 2px 6px;
  background: #00000059;
  border-radius: 5px;
  font-size: 0.75rem;
}

.right-top {
  position: absolute;
  right: 16px;
  top: 17px;
  padding: 2px 6px;
  background: #00000059;
  border-radius: 5px;
  font-size: 0.75rem;
}

.right-bottom {
  position: absolute;
  right: 16px;
  top: 138px;
  padding: 2px 6px;
  background: #00000059;
  border-radius: 5px;
  font-size: 0.75rem;
  color: #fff;
}

.right-top span {
  color: white;
}

.card-title {
  margin: 2px 5px;
  font-size: 1.05rem;
  font-weight: bold;
  display: inline-block;
  width: calc(100% - 15px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.left-top {
  max-width: 80px;
  line-height: 20px;
  height: 20px;
  position: absolute;
  left: 5px;
  top: 5px;
  background: #e56810;
  padding: 0 10px;
  border-radius: 4px;
  font-size: 0.75rem;
  color: white;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.card-base {
  position: relative;
  width: calc((100% - 40px) / 4);
  height: 100%;
  margin-right: 10px;
  margin-bottom: 10px;
}

@media screen and (max-width: 1650px) {
  .card-base {
    position: relative;
    width: calc((100% - 30px) / 3);
    height: 100%;
    margin-right: 10px;
    margin-bottom: 10px;
  }
}

.card-base-b {
  /* padding: 2px; */
  width: 100%;
  height: calc(100% - 5px);
  box-shadow: 0 0 4px #8f8f8f;
  cursor: pointer;
}

.illustrate {
  margin-bottom: 10px;
  font-size: 0.8rem;
  color: #0a5fff;
}
.table-box {
  width: 100%;
  overflow-x: auto;
  max-height: 600px;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.park-detail-top-title3-li1 {
  border-radius: 4px;
  color: #fff;
  text-align: center;
}

.park-detail-top-title3-span1 {
  text-align: center;
  align-items: center;
  font-size: 0.85rem;
  width: 70px;
  height: 25px;
  line-height: 28px;
  display: flex;
  justify-content: center;
  margin-left: 5px;
  margin-top: 5px;
}

.text-center {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 5px;
  width: calc(100% - 15px);
}

.text-bottom {
  height: 35px;
  display: flex;
  justify-content: space-between;
  padding: 0 5px;
  align-items: center;
}

.title {
  font-size: 0.85rem;
  font-weight: bold;
}

.park-detail-base-title {
  font-size: 1.37rem;
  font-weight: bold;
  width: 100%;
  text-align: left;
  color: #057ee5;
  /* background: red; */
}
.park-detail-info-investment-file-li {
  padding: 5px 0;
  cursor: pointer;
  color: #0a75da;
  font-size: 0.85rem;
}

.project-table {
  border-collapse: collapse;
  margin: 20px 0;
  width: 100%;
  border-top: 1px solid #c6c6c6;
  border-left: 1px solid #c6c6c6;
}

.tr-box {
  display: flex;
}

.td-title {
  padding: 20px 0;
  width: 120px;
  text-align: center;
  font-size: 0.85rem;
  font-weight: bold;
  color: #515151;
  display: flex;
  align-items: center;
  justify-content: center;
}

.td-content {
  padding: 20px 10px;
  font-size: 0.85rem;
  color: #6a6a6a;
  border-right: 1px solid #c6c6c6;
  border-bottom: 1px solid #c6c6c6;
}

.td-content1 {
  width: calc((100% - 282px) / 2);
}

.td-conten2 {
  width: calc(100% - 140px);
}

.project-title {
  font-size: 1rem;
  font-weight: 600;
  color: #515151;
}

.project-content {
  font-size: 0.85rem;
  color: #6a6a6a;
  padding: 15px;
  margin: 20px 0;
  width: calc(100% - 30px);
  background: #f0f6ff;
  line-height: 25px;
}

.fw {
  position: absolute;
  top: 22px;
  right: 10px;
  color: #524f4f;
  font-size: 0.95rem;
  padding: 5px 10px;
  background: #fff;
  border-radius: 3px;
  font-size: 0.75rem;
}

.fw-title {
  font-size: 0.85rem;
  font-weight: bold;
}

.fw-b {
  display: flex;
  font-size: 0.8rem;
  margin-top: 3px;
  align-items: center;
}

.fw-box {
  width: 25px;
  height: 12px;
  margin-top: 2px;
  margin-right: 5px;
}
.fw-img {
  width: 20px;
  margin-top: 2px;
  margin-right: 5px;
}
.fw-box1 {
  background: #eb8d13;
}

.fw-box2 {
  background: #aaeb13;
}

.fw-box3 {
  background: #2311a8;
  /* #3196c9; */
}
.fw-box4 {
  background: #04ebf0;
}

.project-address {
  width: 100%;
  /* background: red; */
  height: 50px;
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  color: #837a7a;
}

.contact {
  width: 100%;
  /* height: 40px; */
  /* display: flex; */
  /* align-items: center; */
  /* justify-content: space-between; */
  color: #fff;
  background: #1f42a1de;
  /* background: linear-gradient(90deg, #4196e4c9, #1f42a1de); */
}

.demo-image {
  display: flex;
}

.project-container {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}

.project-title {
  color: #409eff;
  margin: 10px 0px;
  /* background-color: #FFF; */
}

.project-container-box {
  width: 220px;
}

.project-container-box1 {
  width: 500px;
}

.project-container-title {
  font-size: 0.75rem;
  color: #979595;
  margin-top: 15px;
}

.project-container-content {
  font-size: 0.8rem;
  color: #292929;
  margin-top: 5px;
}

.project-container-content1 {
  width: 500px;
  font-size: 0.8rem;
  color: #292929;
  margin-top: 5px;
  line-height: 25px;
}

.project-container-box1 {
  width: 450px;
}

.line {
  background-color: #979595;
  /*背景色为浅灰色*/
  width: 0.6px;
  /*设置宽高*/
  height: 14px;
  margin: 0px 8px;
}
.project-title-details {
  font-weight: 600;
  color: #292929;
}
.project-location {
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: right;
  /* background: red; */
}
.project-location img {
  cursor: pointer;
  width: 30px;
  height: 30px;
}

/* 地块列表 */
.land-list {
  position: absolute;
  top: 50px;
  left: 10px;
  background: #fff;
  /* background: linear-gradient(to right, #03a9f4, #f44336); */
  max-height: 650px;
  width: 300px;
  box-shadow: 0px 0px 6px #cdcdcd;
  overflow: auto;
}
.land-screen {
  position: absolute;
  top: 10px;
  left: 10px;
  background: #fff;
  display: flex;
  width: 300px;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0px 0px 9px #cdcdcd;
  overflow: auto;
}
.land-screen-btn {
  padding: 7px 0;
  width: 25%;
  text-align: center;
  font-size: 0.85rem;
  cursor: pointer;
}
.land-screen-active-btn {
  background: #409eff;
  color: #fff;
}
.land-list1 {
  position: absolute;
  top: 190px;
  left: 10px;
  background: #fff;
  max-height: 650px;

  /* width: 300px; */
}
.land-list-box {
  padding: 10px;
  border-radius: 6px;
}

.land-list-box-li {
  display: flex;
  align-items: center;
  border: 1px solid #e6e6e6;
  padding: 10px;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 10px;
}
.land-list-box-li:last-child {
  margin-bottom: 0;
}
.land-list-box-li-active {
  border-color: #2c83f6;
}
.land-list-box-li-l {
  width: 35px;
  height: 35px;
  border: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}
.land-list-box-li-r {
  width: calc(100% - 45px);
  margin-left: 10px;
}
.land-list-box-li-r-title {
  font-size: 0.85rem;
  color: #3c3c3c;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.land-list-box-li-r-span {
  font-size: 0.75rem;
}
.land-list-box-title {
  margin-bottom: 10px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #0a5fff;
}
.land-list-icon {
  position: absolute;
  top: 50px;
  width: 15px;
  height: 30px;
  background: #ffffffbf;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  color: #004adf;
  cursor: pointer;
}
.programme {
  color: #666666;
  font-size: 0.85rem;
  display: flex;
}
.programme-left {
  width: 74%;
  text-indent: 2em;
}
.programme-right {
  width: 25%;
  background-image: url("../../assets/project/guihuakeyong.png");
  background-size: 100%, 100%;
  background-repeat: no-repeat;
}
</style>
